import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ComboBoxComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { firstValueFrom, interval, Subscription } from 'rxjs';
import { ApprovalDetailsRequestModel } from '~/models/administration/approvalDetailsRequestModel';
import { SiteLisitng } from '~/models/administration/site';
import { SoApprovalCycleRequestModel } from '~/models/administration/soApprovalCycleRequestModel';
import { StockSalesOrderApprovalResponseModel } from '~/models/administration/stockSalesOrderApprovalResponseModel';
import { CustomerListing } from '~/models/modules/customer';
import { AccountsService } from '~/services/administration.ts/accounts';
import { SOApprovalsService } from '~/services/administration.ts/so-approvals';
import { UsersService } from '~/services/administration.ts/users';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { CustomersService } from '~/services/modules/stocks/customers';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'so-approval-cycle.component-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StockAdminSOApprovalsUpsertComponent implements OnInit, OnDestroy {


    @ViewChild('cycleCode') inputCycleCode: ElementRef;
    @ViewChild('kendo_multiselect') kendoMultiselect: MultiSelectComponent;
    @ViewChild('statusComboBox') statusComboBox: ComboBoxComponent;
    @ViewChild('notificationComboBox') notificationComboBox: ComboBoxComponent;
    @ViewChild('creatorPendingNotification') creatorPendingNotification: ComboBoxComponent;
    @ViewChild('creatorApproveNotification') creatorApproveNotification: ComboBoxComponent;
    @ViewChild('creatorRejectNotification') creatorRejectNotification: ComboBoxComponent;
    @ViewChild('numberOfApproverComboBox') numberOfApproverComboBox: ComboBoxComponent;
    @ViewChild('firstApproverComboBox') firstApproverComboBox: ComboBoxComponent;
    @ViewChild('person1ComboBox') person1ComboBox: MultiSelectComponent;
    @ViewChild('firstApproverApprovedComboBox') firstApproverApprovedComboBox: ComboBoxComponent;
    @ViewChild('firstApproverRejectComboBox') firstApproverRejectComboBox: ComboBoxComponent;
    @ViewChild('secondApproverComboBox') secondApproverComboBox: ComboBoxComponent;
    @ViewChild('person2ComboBox') person2ComboBox: ComboBoxComponent;
    @ViewChild('secondApproverApprovedComboBox') secondApproverApprovedComboBox: ComboBoxComponent;
    @ViewChild('secondApproverRejectComboBox') secondApproverRejectComboBox: ComboBoxComponent;

    _pageState: PageState;
    _model: any;
    isEditMode: boolean = false;
    _active: boolean;
    _theme: string;
    _isPendingSalesOrder: boolean = false;
    _pendingSalesOrderNumbers: boolean = false;

    _pendingSalesOrderLength: number;


    sites: SiteLisitng[];
    stockSalesOrderApprovalResponse: StockSalesOrderApprovalResponseModel;
    public persons: any[] = [];
    personsFiltered1: any[];
    personsFiltered2: any[];
    approvalCycleCode: string;
    selectedSites: SiteLisitng[];
    selectedSiteIds: number[] = [];
    customers: CustomerListing[];
    statusValue: any = {
        name: 'Enable',
        value: true
    };
    isEnable: boolean = true;
    selectedCustomers: CustomerListing[] = [];
    _currentNotificationOption: string;
    creator_Email: boolean = false;
    approverApprovesCreator_Email: boolean = false;
    approverApprovesCreator_Cc: boolean = false;
    approverRejectsCreator_Email: boolean = false;
    approverRejectsCreator_Cc: boolean = false;
    creatorEmail: string;
    approvesCreator: string;
    rejectsCreator: string;
    _currentApproverNumber: number;
    _approverNumberValue: number;

    firstApprover: any;
    sndApprover: any;
    selectedPerson1Item: any;
    selectedPerson2Item: any;

    emailCcObjsList: any = {
        person1Id: 0,
        approval1Creator_Email: false,
        isCreatorManager1IsChecked: false,
        isPerson1IsChecked: false,
        isAdminSecurityLevel1IsChecked: false,
        approval1Manager_EmailIsCheckedIsChecked: false,
        approval1Manager_CcIsChecked: false,
        approval1PersonId_EmailIsChecked: false,
        approval1PersonId_CcIsChecked: false,
        approval1AdminSecurityLevelPerson_EmailIsChecked: false,
        approval1AdminSecurityLevelPerson_CcIsChecked: false,
        approval1ApproverRejectsCreator_EmailIsChecked: false,
        approval1ApproverRejectsCreator_CcIsChecked: false,
        approval1Approver1RejectsApprover1_EmailIsChecked: false,
        approval1Approver1RejectsApprover1_CcIsChecked: false,
        approval1Approver1ApprovesCreator_EmailIsChecked: false,
        approval1Approver1ApprovesCreator_CcIsChecked: false,
        approval1Approver1ApprovesApprover1_EmailIsChecked: false,
        approval1Approver1ApprovesApprover1_CcIsChecked: false,

        person2Id: 0,
        isCreatorManager2IsChecked: false,
        isPerson2IsChecked: false,
        isAdminSecurityLevel2IsChecked: false,
        approval2Manager_EmailIsChecked: false,
        approval2Manager_CcIsChecked: false,
        approval2PersonId_EmailIsChecked: false,
        approval2PersonId_CcIsChecked: false,
        approval2AdminSecurityLevel_EmailIsChecked: false,
        approval2AdminSecurityLevel_CcIsChecked: false,
        approval2RejectsCreator_EmailIsChecked: false,
        approval2RejectsCreator_CcIsChecked: false,
        approval2RejectsApprover1_EmailIsChecked: false,
        approval2RejectsApprover1_CcIsChecked: false,
        approval2RejectsApprover2_EmailIsChecked: false,
        approval2RejectsApprover2_CcIsChecked: false,
        approval2ApprovesCreator_EmailIsChecked: false,
        approval2ApprovesCreator_CcIsChecked: false,
        approval2ApprovesApprover1_EmailIsChecked: false,
        approval2ApprovesApprover1_CcIsChecked: false,
        approval2ApprovesApprover2_EmailIsChecked: false,
        approval2ApprovesApprover2_CcIsChecked: false,
    };


    approval1Approver1ApprovesApprover1: any;
    approval1Approver1RejectsApprover1: any;
    approval2ApprovesApprover2: any;
    approval2RejectsApprover1: any;

    _currentStep = 0;


    soApprovalCycleRequest: SoApprovalCycleRequestModel;


    _steps = [
        { label: 'Approval Cycle Info' },
        { label: 'Assign Customers', disabled: true },
        { label: 'SO Creator', disabled: true },
        { label: 'Approver(s)', disabled: true }
    ];

    _approvalStatus = [
        {
            name: 'Enable',
            value: true
        },
        {
            name: 'Disable',
            value: false
        }
    ];

    _booleanData = [
        'Yes',
        'No'
    ];

    _pendingNotification = [
        'None',
        'Email'
    ];

    _notification = [
        'None',
        'Email',
        'CC'
    ];

    _approverNumberData = [
        1,
        2
    ];

    _firstApprover = [
        {
            field: 'isCreatorManager1',
            displayName: 'Creator\'s Manager',
        },
        {
            field: 'isPerson1',
            displayName: 'Choose a person',
        },
        {
            field: 'isAdminSecurityLevel1',
            displayName: 'Any Admin Level Person',
        }
    ];

    _sndApprover = [
        {
            field: 'isCreatorManager2',
            displayName: 'Creator\'s Manager',
        },
        {
            field: 'isPerson2',
            displayName: 'Choose a person',
        },
        {
            field: 'isAdminSecurityLevel2',
            displayName: 'Any Admin Level Person',
        }
    ];


    notificationSubscription: Subscription;
    numberOfApproverSubscription: Subscription;
    loggedInSite: any;
    constructor(
        private _usersService: UsersService,
        private _layoutComponent: LayoutComponent,
        private _themeManager: ThemeManagerService,
        private _soApprovalsService: SOApprovalsService,
        private _customersService: CustomersService,
        private _layoutManager: LayoutManagerService,
        private formBuilder: FormBuilder,
        private _accountService: AccountsService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _sharedService: SharedService,
        private _multiSitesService: MultiSiteService
    ) {
        this.LoadData();
    }


    ngOnInit() {
        if (this._isPendingSalesOrder && this._pendingSalesOrderLength > 0) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Cannot update approval cycle that is related to pending sales orders ( ' + this._pendingSalesOrderLength + ' Pending Sales Orders)',
                withoutConfirm: true
            });
        }
    }



    SetNotificationIntervalListener() {
        var source = interval(500);
        this.notificationSubscription = source.subscribe(val => {
            if (this.notificationComboBox && this.notificationComboBox.isOpen == false) {
                // this.notificationComboBox.isFocused = true;
                this.notificationComboBox.toggle(true);
                this.notificationSubscription.unsubscribe();
            }
        }
        );
    }



    SetNumberOfApproverIntervalListener() {
        var source = interval(500);
        this.numberOfApproverSubscription = source.subscribe(val => {
            if (this.numberOfApproverComboBox && this.numberOfApproverComboBox.isOpen == false) {
                // this.numberOfApproverComboBox.isFocused = true;
                this.numberOfApproverComboBox.toggle(true);
                this.numberOfApproverSubscription.unsubscribe();
            }
        }
        );
    }



    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }


    async LoadData() {
        await this._getdata();


        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();


        this._initPage();

        this.SetNotificationIntervalListener();
        this.SetNumberOfApproverIntervalListener();
    }



    async _getdata() {
        this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
        this._isPendingSalesOrder = this._model.hasPendingSalesOrders;
        this._pendingSalesOrderNumbers = this._model.pendingSalesOrderNumbers;
        this._pendingSalesOrderLength = this._model.pendingSalesOrderNumbers?.length;
        this.isEditMode = this._sharedService.model && this._sharedService.model.model && this._sharedService.model.model.id && this._sharedService.model.model.id > 0 ? true : false;
        this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
        this._active = true;
    }


    public isItemDisabled(item: { dataItem: any, id: any, text: string, value: string }): boolean {
        //return item.disabled === true;
        if (this.loggedInSite > 0 && this.loggedInSite !== SitesEnum.AllSites)
            return this.loggedInSite != item['dataItem'].id;
        else
            return false;
    }
    private async _initPage() {
        var accountSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
        if (accountSites && accountSites.length > 0)
            this.loggedInSite = accountSites[0].siteId;

        const result = await firstValueFrom(this._multiSitesService.getAllSites());
        this.sites = (result as any) || [];
        if (accountSites && accountSites.length > 0 && accountSites[0].siteId > 0 && accountSites[0].siteId !== SitesEnum.AllSites) {
            this.sites = this.sites.filter(x => x.id == accountSites[0].siteId || x.id == SitesEnum.AllSites);
        }

        //Push First Site Untill handle multi sites
        this.selectedSites = [];
        // this.selectedSites.push(this.sites[0]);
        // this.selectedSiteIds.push(this.sites[0].id);
        this.customers = [];

        if (this.inputCycleCode) {
            this.inputCycleCode.nativeElement.focus();
        }

        if (this.isEditMode) {
            this.stockSalesOrderApprovalResponse = this._model;
            this._steps.forEach(step => step.disabled = false);
        }
        else {
            this.stockSalesOrderApprovalResponse = null;
        }

        if (this.isEditMode && this.stockSalesOrderApprovalResponse) {
            this.approvalCycleCode = this.stockSalesOrderApprovalResponse.code;

            this.selectedSites = [];
            this.stockSalesOrderApprovalResponse.soApprovalSites?.forEach(element => {
                const targetSiteId = element.siteId ?? element.site?.id;
                if (targetSiteId != null) {
                    var selectedSite = this.sites.find(f => f.id == targetSiteId);
                    if (selectedSite)
                        this.selectedSites.push(selectedSite);
                }
                else {
                    var selectedSite = this.sites.find(f => f.id == 0 || f.id == SitesEnum.AllSites);
                    if (selectedSite)
                        this.selectedSites.push(selectedSite);
                }
            });
            await this.SiteNameSelected(this.selectedSites, true);

            try {
                const persons = await firstValueFrom(this._usersService.getPersonsIsUsers(this.selectedSiteIds));
                this.persons = this.personsFiltered1 = this.personsFiltered2 = persons;
            } catch {
                this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
            }

            if (this.stockSalesOrderApprovalResponse.enableCycle == true) {
                var enableStatus: any = {
                    name: 'Enable',
                    value: true
                };

                this.statusValue = enableStatus;
                this.isEnable = true;
            }
            else if (this.stockSalesOrderApprovalResponse.enableCycle == false) {
                var disableStatus: any = {
                    name: 'Disable',
                    value: false
                };

                this.statusValue = disableStatus;
                this.isEnable = false;
            }

            this.selectedCustomers = [];

            var soCustomerApprovals = this.stockSalesOrderApprovalResponse.soApprovalSites?.map(x => x.soCustomerApprovals) || [];

            soCustomerApprovals.forEach(element => {
                element?.forEach(soCustomerApproval => {
                    if (soCustomerApproval?.customer && !this.selectedCustomers.find(x => x.code == soCustomerApproval.customer.code))
                        this.selectedCustomers.push(soCustomerApproval.customer);
                });
            });

                if (this.stockSalesOrderApprovalResponse?.soApprovalDetails && this.stockSalesOrderApprovalResponse.soApprovalDetails.length > 0) {
                    if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].creator_Email == true ||
                        this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Email == true ||
                        this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Cc == true ||
                        this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Email == true ||
                        this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Cc == true) {
                        this._notificationOptionChange('Yes');

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].creator_Email == true) {
                            this.PendingRequestNotification('Email');
                        }
                        else {
                            this.PendingRequestNotification('None')
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Email == true) {
                            this.ApprovedRequestNotification('Email');
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Cc == true) {
                            this.ApprovedRequestNotification('CC');
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Email == false &&
                            this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverApprovesCreator_Cc == false) {
                            this.ApprovedRequestNotification('None');
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Email == true) {
                            this.RejectedRequestNotification('Email');
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Cc == true) {
                            this.RejectedRequestNotification('CC');
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Email == false &&
                            this.stockSalesOrderApprovalResponse.soApprovalDetails[0].approverRejectsCreator_Cc == false) {
                            this.RejectedRequestNotification('None');
                        }

                    }
                    else {
                        this._notificationOptionChange('No');
                    }
                }

                if (this.stockSalesOrderApprovalResponse && this.stockSalesOrderApprovalResponse.soApprovalDetails && this.stockSalesOrderApprovalResponse.soApprovalDetails.length) {
                    this._currentApproverNumber = this.stockSalesOrderApprovalResponse.soApprovalDetails.length;
                    this._approverNumberChange(this._currentApproverNumber);
                }

                for (var i = 0; i < this.stockSalesOrderApprovalResponse.soApprovalDetails.length; i++) {
                    if (i == 0) {
                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isCreatorManager) {
                            var creatorManager = {
                                field: 'isCreatorManager1',
                                displayName: 'Creator\'s Manager',
                            };
                            this.firstApprover = creatorManager;
                            this.PickApprover(creatorManager);

                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isPerson) {

                            var person =
                            {
                                field: 'isPerson1',
                                displayName: 'Choose a person',
                            };
                            this.firstApprover = person;
                            this.PickApprover(person);

                            var selectedPerson = this.personsFiltered1.find(f => f.id == this.stockSalesOrderApprovalResponse.soApprovalDetails[i].personId);
                            this.selectedPerson1Item = selectedPerson;
                            this.onPersonsGridSelectionChange(this.selectedPerson1Item, 1);
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isAdminSecurityLevel) {
                            var adminSecurityLevel = {
                                field: 'isAdminSecurityLevel1',
                                displayName: 'Any Admin Level Person',
                            };

                            this.firstApprover = adminSecurityLevel;
                            this.PickApprover(adminSecurityLevel);
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Email) {
                            this.ApproverConfiguration('Email', 'approved', 1);
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Cc) {
                            this.ApproverConfiguration('CC', 'approved', 1);
                        }
                        else if (!this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Email && !this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Cc) {
                            this.ApproverConfiguration('None', 'approved', 1);
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Email) {
                            this.ApproverConfiguration('Email', 'rejected', 1)
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Cc) {
                            this.ApproverConfiguration('CC', 'rejected', 1)
                        }
                        else if (!this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Email && !this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Cc) {
                            this.ApproverConfiguration('None', 'rejected', 1)
                        }

                    }
                    else if (i == 1) {
                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isCreatorManager) {
                            var creatorManager = {
                                field: 'isCreatorManager2',
                                displayName: 'Creator\'s Manager',
                            };
                            this.sndApprover = creatorManager;
                            this.PickApprover(creatorManager);

                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isPerson) {

                            var person =
                            {
                                field: 'isPerson2',
                                displayName: 'Choose a person',
                            };
                            this.sndApprover = person;
                            this.PickApprover(person);


                            var selectedPerson = this.personsFiltered2.find(f => f.id == this.stockSalesOrderApprovalResponse.soApprovalDetails[i].personId);
                            this.selectedPerson2Item = selectedPerson;
                            this.onPersonsGridSelectionChange(this.selectedPerson2Item, 2);

                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].isAdminSecurityLevel) {
                            var adminSecurityLevel = {
                                field: 'isAdminSecurityLevel2',
                                displayName: 'Any Admin Level Person',
                            };

                            this.sndApprover = adminSecurityLevel;
                            this.PickApprover(adminSecurityLevel);
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Email) {
                            this.ApproverConfiguration('Email', 'approved', 2);
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Cc) {
                            this.ApproverConfiguration('CC', 'approved', 2);
                        }
                        else if (!this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Email && !this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverApprovesApprover_Cc) {
                            this.ApproverConfiguration('None', 'approved', 2);
                        }

                        if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Email) {
                            this.ApproverConfiguration('Email', 'rejected', 2)
                        }
                        else if (this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Cc) {
                            this.ApproverConfiguration('CC', 'rejected', 2)
                        }
                        else if (!this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Email && !this.stockSalesOrderApprovalResponse.soApprovalDetails[i].approverRejectsApprover_Cc) {
                            this.ApproverConfiguration('None', 'rejected', 2)
                        }
                    }
            }
        }
    }


    async SiteNameSelected(sites: SiteLisitng[], FromEdit: boolean = false) {
        this.selectedSiteIds = [];
        sites.forEach(element => {
            this.selectedSiteIds.push(element.id);
        });

        if (!FromEdit) {
            this.customers = this.selectedCustomers = [];

            this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
            this.selectedPerson1Item = this.selectedPerson2Item = null;
        }
        if (this.selectedSiteIds && this.selectedSiteIds.length > 0) {
            try {
                this.customers = await firstValueFrom(this._customersService.getCustomersBySiteId(this.selectedSiteIds));
            } catch {
                this.customers = [];
            }
            if (!FromEdit) {
                try {
                    const persons = await firstValueFrom(this._usersService.getPersonsIsUsers(this.selectedSiteIds));
                    this.persons = this.personsFiltered1 = this.personsFiltered2 = persons;
                } catch {
                    this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
                }
            }
        }
    }


    async _notificationOptionChange(value: any) {
        this._currentNotificationOption = value;
        if (this._currentNotificationOption === 'Yes') {
            this.creatorEmail = undefined;
            this.approvesCreator = undefined;
            this.rejectsCreator = undefined;

            await this.delay(300)

            if (this.creatorPendingNotification) {
                // this.creatorPendingNotification.isFocused = true;
                this.creatorPendingNotification.toggle(true);
            }
        }
        if (this._currentNotificationOption === 'No') {
            this.creator_Email = false;
            this.approverApprovesCreator_Email = false;
            this.approverApprovesCreator_Cc = false;
            this.approverRejectsCreator_Email = false;
            this.approverRejectsCreator_Cc = false;
            this.creatorEmail = undefined;
            this.approvesCreator = undefined;
            this.rejectsCreator = undefined;
        }
    }


    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    OpenSiteComboBox() {
        // this.kendoMultiselect.isFocused = true;
        this.kendoMultiselect.toggle(true);
    }

    OpenStatusComboBox() {
        // this.statusComboBox.isFocused = true;
        this.statusComboBox.toggle(true);
    }


    async PendingRequestNotification(event: any) {
        this.creatorEmail = event;
        if (event && event.toLowerCase() == 'email') {
            this.creator_Email = true;
        }
        else {
            this.creator_Email = false;
        }

        await this.delay(300);

        if (this.creatorApproveNotification) {
            // this.creatorApproveNotification.isFocused = true;
            this.creatorApproveNotification.toggle(true);
        }
    }


    async ApprovedRequestNotification(event: any) {
        this.approvesCreator = event;
        if (event && event.toLowerCase() == 'email') {
            this.approverApprovesCreator_Email = true;
            this.approverApprovesCreator_Cc = false;
        }
        else if (event && event.toLowerCase() == 'cc') {
            this.approverApprovesCreator_Email = false;
            this.approverApprovesCreator_Cc = true;
        }
        else {
            this.approverApprovesCreator_Email = false;
            this.approverApprovesCreator_Cc = false;
        }


        await this.delay(300);
        if (this.creatorRejectNotification) {
            // this.creatorRejectNotification.isFocused = true;
            this.creatorRejectNotification.toggle(true);
        }
    }


    RejectedRequestNotification(event: any) {
        this.rejectsCreator = event;
        if (event && event.toLowerCase() == 'email') {
            this.approverRejectsCreator_Email = true;
            this.approverRejectsCreator_Cc = false;
        }
        else if (event && event.toLowerCase() == 'cc') {
            this.approverRejectsCreator_Email = false;
            this.approverRejectsCreator_Cc = true;
        }
        else {
            this.approverRejectsCreator_Email = false;
            this.approverRejectsCreator_Cc = false;
        }
    }


    async _approverNumberChange(value: any) {
        this._currentApproverNumber = value;
        if (this._currentApproverNumber === 1) {
            this._approverNumberValue = 1;
        }
        else if (this._currentApproverNumber === 2) {
            this._approverNumberValue = 2;
        }
        else {
            this._approverNumberValue = undefined;
        }


        await this.delay(500);

        if (this.firstApproverComboBox) {
            // this.firstApproverComboBox.isFocused = true;
            this.firstApproverComboBox.toggle(true);
        }
    }



    async PickApprover(event: any) {
        if (event && event.field == 'isCreatorManager1') {
            this.firstApprover = event;
            this.emailCcObjsList.isCreatorManager1IsChecked = true;
            this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = true;
            this.emailCcObjsList.approval1Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson1IsChecked = false;
            this.emailCcObjsList.approval1PersonId_EmailIsChecked = false;
            this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = false;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;


            if (this.firstApproverApprovedComboBox) {
                // this.firstApproverApprovedComboBox.isFocused = true;
                this.firstApproverApprovedComboBox.toggle(true);
            }
        }
        else if (event && event.field == 'isPerson1') {
            this.firstApprover = event;
            this.emailCcObjsList.isCreatorManager1IsChecked = false;
            this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = false;
            this.emailCcObjsList.approval1Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson1IsChecked = true;
            this.emailCcObjsList.approval1PersonId_EmailIsChecked = true;
            this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = false;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;


            await this.delay(500)

            if (this.person1ComboBox) {
                // this.person1ComboBox.isFocused = true;
                this.person1ComboBox.toggle(true);
            }

        }
        else if (event && event.field == 'isAdminSecurityLevel1') {
            this.firstApprover = event;
            this.emailCcObjsList.isCreatorManager1IsChecked = false;
            this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = false;
            this.emailCcObjsList.approval1Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson1IsChecked = false;
            this.emailCcObjsList.approval1PersonId_EmailIsChecked = false;
            this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel1IsChecked = true;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = true;
            this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;


            if (this.firstApproverApprovedComboBox) {
                // this.firstApproverApprovedComboBox.isFocused = true;
                this.firstApproverApprovedComboBox.toggle(true);
            }
        }
        else if (event && event.field == 'isCreatorManager2') {
            this.sndApprover = event;
            this.emailCcObjsList.isCreatorManager2IsChecked = true;
            this.emailCcObjsList.approval2Manager_EmailIsChecked = true;
            this.emailCcObjsList.approval2Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson2IsChecked = false;
            this.emailCcObjsList.approval2PersonId_EmailIsChecked = false;
            this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
            this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = false;
            this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;

            if (this.secondApproverApprovedComboBox) {
                // this.secondApproverApprovedComboBox.isFocused = true;
                this.secondApproverApprovedComboBox.toggle(true);
            }
        }
        else if (event && event.field == 'isPerson2') {
            this.sndApprover = event;
            this.emailCcObjsList.isCreatorManager2IsChecked = false;
            this.emailCcObjsList.approval2Manager_EmailIsChecked = false;
            this.emailCcObjsList.approval2Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson2IsChecked = true;
            this.emailCcObjsList.approval2PersonId_EmailIsChecked = true;
            this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
            this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = false;
            this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;


            await this.delay(500)
            if (this.person2ComboBox) {
                // this.person2ComboBox.isFocused = true;
                this.person2ComboBox.toggle(true);
            }
        }
        else if (event && event.field == 'isAdminSecurityLevel2') {
            this.sndApprover = event;
            this.emailCcObjsList.isCreatorManager2IsChecked = false;
            this.emailCcObjsList.approval2Manager_EmailIsChecked = false;
            this.emailCcObjsList.approval2Manager_CcIsChecked = false;
            this.emailCcObjsList.isPerson2IsChecked = false;
            this.emailCcObjsList.approval2PersonId_EmailIsChecked = false;
            this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel2IsChecked = true;
            this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = true;
            this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;


            if (this.secondApproverApprovedComboBox) {
                // this.secondApproverApprovedComboBox.isFocused = true;
                this.secondApproverApprovedComboBox.toggle(true);
            }
        }
        else if (!event) {
            this.firstApprover = undefined;
            this.sndApprover = undefined;
            this.emailCcObjsList.isCreatorManager1IsChecked = false;
            this.emailCcObjsList.isPerson1IsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
            this.emailCcObjsList.isCreatorManager2IsChecked = false;
            this.emailCcObjsList.isPerson2IsChecked = false;
            this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
        }
    }



    onPersonsGridSelectionChange(event: any, idx: number) {
        if (event) {
            if (idx === 1) {
                this.emailCcObjsList.person1Id = event.id;


                if (this.firstApproverApprovedComboBox) {
                    // this.firstApproverApprovedComboBox.isFocused = true;
                    this.firstApproverApprovedComboBox.toggle(true);
                }

            }
            else if (idx === 2) {
                this.emailCcObjsList.person2Id = event.id;


                if (this.secondApproverApprovedComboBox) {
                    // this.secondApproverApprovedComboBox.isFocused = true;
                    this.secondApproverApprovedComboBox.toggle(true);
                }
            }
        }
        else if (!event) {
            this.emailCcObjsList.person1Id = 0;
            this.emailCcObjsList.person2Id = 0;
        }
    }



    ApproverConfiguration(event: any, key: string, idx: number) {
        if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'approved' && idx == 1) {
            this.approval1Approver1ApprovesApprover1 = event;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;


            if (this.firstApproverRejectComboBox) {
                // this.firstApproverRejectComboBox.isFocused = true;
                this.firstApproverRejectComboBox.toggle(true);
            }
        }
        else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'approved' && idx == 1) {
            this.approval1Approver1ApprovesApprover1 = event;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = false;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = true;


            if (this.firstApproverRejectComboBox) {
                // this.firstApproverRejectComboBox.isFocused = true;
                this.firstApproverRejectComboBox.toggle(true);
            }
        }
        else if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'rejected' && idx == 1) {
            this.approval1Approver1RejectsApprover1 = event;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;


            if (this.secondApproverComboBox) {
                // this.secondApproverComboBox.isFocused = true;
                this.secondApproverComboBox.toggle(true);
            }

        }
        else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'rejected' && idx == 1) {
            this.approval1Approver1RejectsApprover1 = event;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = false;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = true;


            if (this.secondApproverComboBox) {
                // this.secondApproverComboBox.isFocused = true;
                this.secondApproverComboBox.toggle(true);
            }

        }
        else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'approved' && idx == 1) {
            this.approval1Approver1ApprovesApprover1 = event;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = false;
            this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;


            if (this.firstApproverRejectComboBox) {
                // this.firstApproverRejectComboBox.isFocused = true;
                this.firstApproverRejectComboBox.toggle(true);
            }
        }
        else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'rejected' && idx == 1) {
            this.approval1Approver1RejectsApprover1 = event;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = false;
            this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;


            if (this.secondApproverComboBox) {
                // this.secondApproverComboBox.isFocused = true;
                this.secondApproverComboBox.toggle(true);
            }
        }

        //------------------------------- 2nd approval ----------------------------------------

        if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'approved' && idx == 2) {
            this.approval2ApprovesApprover2 = event;
            this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
            this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;


            if (this.secondApproverRejectComboBox) {
                // this.secondApproverRejectComboBox.isFocused = true;
                this.secondApproverRejectComboBox.toggle(true);
            }
        }
        else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'approved' && idx == 2) {
            this.approval2ApprovesApprover2 = event;
            this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = false;
            this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = true;


            if (this.secondApproverRejectComboBox) {
                // this.secondApproverRejectComboBox.isFocused = true;
                this.secondApproverRejectComboBox.toggle(true);
            }
        }
        else if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'rejected' && idx == 2) {
            this.approval2RejectsApprover1 = event;
            this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
            this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
        }
        else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'rejected' && idx == 2) {
            this.approval2RejectsApprover1 = event;
            this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = false;
            this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = true;
        }
        else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'approved' && idx == 2) {
            this.approval2ApprovesApprover2 = event;
            this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = false;
            this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;

            if (this.secondApproverRejectComboBox) {
                // this.secondApproverRejectComboBox.isFocused = true;
                this.secondApproverRejectComboBox.toggle(true);
            }
        }
        else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'rejected' && idx == 2) {
            this.approval2RejectsApprover1 = event;
            this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = false;
            this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
        }
    }

    isItemSelected(id: any) {
        return this.selectedSiteIds.some(item => item === id);
    }


    _closeForm() {
        var closeComponent = {
            component: 'soApprovals',
            isClosed: true
        }

        this._active = false;
        this.ngOnDestroy();

        this._sharedService.closeDialog.emit(closeComponent);
        this._gridLayoutManagerService.setGridDataSubjects('soApprovals');
        this._sharedService.model = {};
    }


    SelectedStatus(event: any) {
        if (!event) {
            this.isEnable = undefined;
        }
        else {
            this.isEnable = event.value;
        }
    }

    onStatusRadioChange(enable: boolean) {
        this.isEnable = enable;
        this.statusValue = enable ? { name: 'Enable', value: true } : { name: 'Disable', value: false };
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }



    GetSelectedCustomers(event: any) {
        this.selectedCustomers = [];
        this.selectedCustomers = event;

    }


    handlePersonItemsFilter(value: any, index: number) {
        if (index === 1) {
            this.personsFiltered1 = this.persons.filter(
                (s) => s.firstName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
                    s.lastName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
                    s.code?.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }
        else if (index === 2) {
            this.personsFiltered2 = this.persons.filter(
                (s) => s.firstName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
                    s.lastName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
                    s.code?.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }

    }




    NavigateToTheNextStep() {
        if (this._isPendingSalesOrder) {
            if (this._currentStep < this._steps.length - 1) {
                this._currentStep += 1;
                this._steps[this._currentStep]['disabled'] = false;
                return;
            }
        }
        if (this._currentStep == 0) {
            if (this.approvalCycleCode &&
                this.approvalCycleCode.length > 0 &&
                this.selectedSiteIds &&
                this.selectedSiteIds.length > 0 &&
                this.isEnable != undefined) {
                if (this._currentStep < this._steps.length - 1) {
                    this._currentStep += 1;
                    this._steps[this._currentStep]['disabled'] = false;
                    return;
                }
            }
        }
        if (this._currentStep == 1) {
            if (this.selectedCustomers && this.selectedCustomers.length > 0) {
                if (this._currentStep < this._steps.length - 1) {
                    this._currentStep += 1;
                    this._steps[this._currentStep]['disabled'] = false;
                    return;
                }
            }
        }
        if (this._currentStep == 2) {
            if (this._currentNotificationOption && (this._currentNotificationOption.toLowerCase() == 'yes' || this._currentNotificationOption.toLowerCase() == 'no')) {
                if (this._currentStep < this._steps.length - 1) {
                    this._currentStep += 1;
                    this._steps[this._currentStep]['disabled'] = false;
                    return;
                }
            }
        }
    }


    previousStep() {
        if (this._currentStep > 0) {
            this._currentStep -= 1;


            if (!this.notificationSubscription || this.notificationSubscription.closed == true) {
                this.SetNotificationIntervalListener();
            }
            if (!this.numberOfApproverSubscription || this.numberOfApproverSubscription.closed == true) {
                this.SetNumberOfApproverIntervalListener();
            }

        }
    }


    _onSave(e: any) {
        this.submit();
    }

    private submit = () => {
        if (!this.approvalCycleCode || !this.selectedSiteIds || this.selectedSiteIds.length == 0 || this.isEnable == undefined) {
            return;
        }
        if (this.isEnable !== false) {
            if (!this._approverNumberValue || this._approverNumberValue == 0) {
                return
            }
            else if (this._approverNumberValue > 0) {
                if (this._approverNumberValue == 1 &&
                    this.emailCcObjsList.isCreatorManager1IsChecked == false &&
                    (this.emailCcObjsList.isPerson1IsChecked == false || (this.emailCcObjsList.isPerson1IsChecked == true && this.emailCcObjsList.person1Id == 0)) &&
                    this.emailCcObjsList.isAdminSecurityLevel1IsChecked == false) {
                    return;
                }
                else if (this._approverNumberValue == 2 && (
                    (this.emailCcObjsList.isCreatorManager1IsChecked == false &&
                        this.emailCcObjsList.isPerson1IsChecked == false &&
                        this.emailCcObjsList.isAdminSecurityLevel1IsChecked == false) ||
                    (
                        this.emailCcObjsList.isCreatorManager2IsChecked == false &&
                        (this.emailCcObjsList.isPerson2IsChecked == false || (this.emailCcObjsList.isPerson2IsChecked == true && this.emailCcObjsList.person2Id == 0)) &&
                        this.emailCcObjsList.isAdminSecurityLevel2IsChecked == false)
                )) {
                    return;
                }
            }
        }


        this.soApprovalCycleRequest = new SoApprovalCycleRequestModel();
        this.soApprovalCycleRequest.code = this.approvalCycleCode;
        this.soApprovalCycleRequest.sitesId = this.selectedSiteIds;
        this.soApprovalCycleRequest.isEnable = this.isEnable;
        this.soApprovalCycleRequest.customerIds = this.selectedCustomers.map(x => x.id);

        var soApprovalDetailsRequests: ApprovalDetailsRequestModel[] = [];

        this.ValidateEmail(1);

        if (this._approverNumberValue) {
            for (var i = 0; i < this._approverNumberValue; i++) {
                if (i == 0) {
                    var soApprovalDetailsRequest = new ApprovalDetailsRequestModel();
                    soApprovalDetailsRequest.creator_Email = this.creator_Email;


                    soApprovalDetailsRequest.approverApprovesCreator_Email = this.approverApprovesCreator_Email;
                    soApprovalDetailsRequest.approverApprovesCreator_Cc = this.approverApprovesCreator_Cc;
                    soApprovalDetailsRequest.approverRejectsCreator_Email = this.approverRejectsCreator_Email;
                    soApprovalDetailsRequest.approverRejectsCreator_Cc = this.approverRejectsCreator_Cc;

                    soApprovalDetailsRequest.isCreatorManager = this.emailCcObjsList.isCreatorManager1IsChecked;
                    soApprovalDetailsRequest.manager_Email = this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked;
                    soApprovalDetailsRequest.manager_Cc = this.emailCcObjsList.approval1Manager_CcIsChecked;
                    soApprovalDetailsRequest.isPerson = this.emailCcObjsList.isPerson1IsChecked;
                    if (this.emailCcObjsList.person1Id > 0) {
                        soApprovalDetailsRequest.personId = this.emailCcObjsList.person1Id;
                    }
                    soApprovalDetailsRequest.personId_Email = this.emailCcObjsList.approval1PersonId_EmailIsChecked;
                    soApprovalDetailsRequest.personId_Cc = this.emailCcObjsList.approval1PersonId_CcIsChecked;
                    soApprovalDetailsRequest.isAdminSecurityLevel = this.emailCcObjsList.isAdminSecurityLevel1IsChecked;
                    soApprovalDetailsRequest.adminSecurityLevelPerson_Email = this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked;
                    soApprovalDetailsRequest.adminSecurityLevelPerson_Cc = this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked;
                    soApprovalDetailsRequest.approverApprovesApprover_Email = this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked;
                    soApprovalDetailsRequest.approverApprovesApprover_Cc = this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked;
                    soApprovalDetailsRequest.approverRejectsApprover_Email = this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked;
                    soApprovalDetailsRequest.approverRejectsApprover_Cc = this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked;
                    soApprovalDetailsRequest.order = 1;

                    soApprovalDetailsRequests.push(soApprovalDetailsRequest);
                }
                else {
                    this.ValidateEmail(2);
                    var soApprovalDetailsRequest = new ApprovalDetailsRequestModel();
                    soApprovalDetailsRequest.creator_Email = this.creator_Email;


                    soApprovalDetailsRequest.approverApprovesCreator_Email = this.approverApprovesCreator_Email;
                    soApprovalDetailsRequest.approverApprovesCreator_Cc = this.approverApprovesCreator_Cc;
                    soApprovalDetailsRequest.approverRejectsCreator_Email = this.approverRejectsCreator_Email;
                    soApprovalDetailsRequest.approverRejectsCreator_Cc = this.approverRejectsCreator_Cc;

                    soApprovalDetailsRequest.isCreatorManager = this.emailCcObjsList.isCreatorManager2IsChecked;
                    soApprovalDetailsRequest.manager_Email = this.emailCcObjsList.approval2Manager_EmailIsChecked;
                    soApprovalDetailsRequest.manager_Cc = this.emailCcObjsList.approval2Manager_CcIsChecked;
                    soApprovalDetailsRequest.isPerson = this.emailCcObjsList.isPerson2IsChecked;
                    if (this.emailCcObjsList.person2Id > 0) {
                        soApprovalDetailsRequest.personId = this.emailCcObjsList.person2Id;
                    }
                    soApprovalDetailsRequest.personId_Email = this.emailCcObjsList.approval2PersonId_EmailIsChecked;
                    soApprovalDetailsRequest.personId_Cc = this.emailCcObjsList.approval2PersonId_CcIsChecked;
                    soApprovalDetailsRequest.isAdminSecurityLevel = this.emailCcObjsList.isAdminSecurityLevel2IsChecked;
                    soApprovalDetailsRequest.adminSecurityLevelPerson_Email = this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked;
                    soApprovalDetailsRequest.adminSecurityLevelPerson_Cc = this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked;
                    soApprovalDetailsRequest.approverApprovesApprover_Email = this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked;
                    soApprovalDetailsRequest.approverApprovesApprover_Cc = this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked;
                    soApprovalDetailsRequest.approverRejectsApprover_Email = this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked;
                    soApprovalDetailsRequest.approverRejectsApprover_Cc = this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked;
                    soApprovalDetailsRequest.order = 2;

                    soApprovalDetailsRequests.push(soApprovalDetailsRequest);
                }
            }
        }


        this.soApprovalCycleRequest.soApprovalDetails = soApprovalDetailsRequests;
        if (this.stockSalesOrderApprovalResponse) {
            this._soApprovalsService
                .updateStockSalesOrderApproval(this.soApprovalCycleRequest, this.stockSalesOrderApprovalResponse.id)

                .subscribe((response: any) => {

                    this._closeForm();

                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: 'Approval Cycle Updated Successfully.',
                        withoutConfirm: true
                    });
                }
                    // , _ => {
                    //     this._layoutComponent.openPopup({
                    //         title: 'Alert',
                    //         message: 'The sales order approval code already exist or the customer is already assigned to another sales order approval.',
                    //         withoutConfirm: true
                    //       });
                    // }
                );
        }
        else {
            this._soApprovalsService
                .createStockSalesOrderApproval(this.soApprovalCycleRequest)

                .subscribe((response: any) => {


                    this._closeForm();

                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: 'Approval Cycle Saved Successfully.',
                        withoutConfirm: true
                    });
                }
                    // , _ => {
                    //     this._layoutComponent.openPopup({
                    //         title: 'Alert',
                    //         message: 'The sales order approval code already exist or the customer is already assigned to another sales order approval.',
                    //         withoutConfirm: true
                    //     });
                    // }
                );
        }
    }




    ValidateEmail(idx: number) {
        if (idx == 1) {
            if (this.approverApprovesCreator_Cc == true && this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == true) {
                this.approverApprovesCreator_Cc = false;
                this.approverApprovesCreator_Email = true;
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;
            }
            if (this.approverApprovesCreator_Email == false &&
                this.approverApprovesCreator_Cc == false &&
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == true) {
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;
            }
            if (this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked == false &&
                this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == false &&
                this.approverApprovesCreator_Cc == true) {
                this.approverApprovesCreator_Email = true;
                this.approverApprovesCreator_Cc = false;
            }

            //--------------------------------------------- reject ---------------------------------------------

            if (this.approverRejectsCreator_Cc == true && this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == true) {
                this.approverRejectsCreator_Email = true;
                this.approverRejectsCreator_Cc = false;
                this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
                this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;
            }

            if (this.approverRejectsCreator_Email == false &&
                this.approverRejectsCreator_Cc == false &&
                this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == true) {
                this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
                this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false
            }

            if (this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked == false &&
                this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == false &&
                this.approverRejectsCreator_Cc == true) {
                this.approverRejectsCreator_Email = true;
                this.approverRejectsCreator_Cc = false;
            }
        }
        else if (idx == 2) {
            if (this.approverApprovesCreator_Cc == true && this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == true) {
                this.approverApprovesCreator_Cc = false;
                this.approverApprovesCreator_Email = true;
                this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
                this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;
            }
            if (this.approverApprovesCreator_Email == false &&
                this.approverApprovesCreator_Cc == false &&
                this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == true) {
                this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
                this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;
            }
            if (this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked == false &&
                this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == false &&
                this.approverApprovesCreator_Cc == true) {
                this.approverApprovesCreator_Email = true;
                this.approverApprovesCreator_Cc = false;
            }

            //--------------------------------------------- reject ---------------------------------------------

            if (this.approverRejectsCreator_Cc == true && this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == true) {
                this.approverRejectsCreator_Email = true;
                this.approverRejectsCreator_Cc = false;
                this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
                this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
            }

            if (this.approverRejectsCreator_Email == false &&
                this.approverRejectsCreator_Cc == false &&
                this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == true) {
                this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
                this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false
            }

            if (this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked == false &&
                this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == false &&
                this.approverRejectsCreator_Cc == true) {
                this.approverRejectsCreator_Email = true;
                this.approverRejectsCreator_Cc = false;
            }
        }

    }

}
